import type { Board } from './types';

/** Board colors offered by the picker (also the pool for the derived default). */
export const BOARD_COLOR_PRESETS = [
  '#4c8dff',
  '#2bb3a3',
  '#4cc283',
  '#a3c93a',
  '#f2b134',
  '#ff8a4c',
  '#f0656f',
  '#e060b0',
  '#a678e8',
  '#8a94a6',
] as const;

/**
 * The color to show for a board: its own, or a stable default derived from its id (the same
 * board always gets the same color, neighbours differ). Never stored.
 */
export function boardColor(board: Pick<Board, 'id' | 'color'>): string {
  if (board.color) return board.color;
  let hash = 0;
  for (const char of board.id) hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  return BOARD_COLOR_PRESETS[hash % BOARD_COLOR_PRESETS.length] ?? BOARD_COLOR_PRESETS[0];
}
